import LegalPage from "@/components/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms &amp; Conditions" lastUpdated="17 September 2026">
      <p>
        These Terms and Conditions ("Terms") govern your access to and use of{" "}
        <strong>voicematrix.in</strong> and related services ("Service") operated by{" "}
        <strong>VoiceMatrixAI</strong> ("we", "us", "our"). By accessing or using the
        Service, you agree to these Terms.
      </p>

      <h2>1. Eligibility</h2>
      <p>
        You must be at least 18 years old to use the Service. By using it, you confirm
        you meet this requirement.
      </p>

      <h2>2. Nature of the Service</h2>
      <p>The Service provides:</p>
      <ul>
        <li>Voice-frequency analysis for wellness reflection</li>
        <li>Astrological reports derived from voice-frequency patterns</li>
        <li>Digital products: audio tracks, PDF guides, remedy collections</li>
        <li>Online workshops and consultations</li>
      </ul>
      <p>
        <strong>The Service is not a medical, psychological, financial, or legal service.</strong>{" "}
        All outputs are for personal reflection and wellness purposes only. Nothing on
        the Service constitutes medical advice, diagnosis, or treatment.
      </p>

      <h2>3. Account Registration</h2>
      <ul>
        <li>You must provide accurate information.</li>
        <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
        <li>You must verify your email address before using scan features.</li>
        <li>We may suspend or terminate accounts that violate these Terms.</li>
      </ul>

      <h2>4. Voice Recordings and Consent</h2>
      <p>By submitting a voice recording:</p>
      <ul>
        <li>You confirm the recording is your own voice.</li>
        <li>You consent to its analysis by our AI systems and third-party providers as described in the Privacy Policy.</li>
        <li>You understand that outputs are assistive and not diagnostic.</li>
      </ul>

      <h2>5. Purchases and Payment</h2>
      <ul>
        <li>All prices are in Indian Rupees (₹) and inclusive of applicable GST unless stated otherwise.</li>
        <li>Payments are processed by Stripe and Razorpay. We do not store card or UPI credentials.</li>
        <li>Digital products are delivered instantly upon successful payment.</li>
        <li>Reports requiring analysis are delivered within the timeframe stated on the product page.</li>
        <li>Subscription memberships renew automatically unless cancelled.</li>
      </ul>

      <h2>6. Refunds</h2>
      <p>
        Refunds are governed by our{" "}
        <a href="/refund">Refund &amp; Cancellation Policy</a>, incorporated into these
        Terms.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        All content on the Service — text, images, audio, reports, methodologies, and
        the Swar Nakshatra Jyotish framework — is owned by us or licensed to us. You
        may not:
      </p>
      <ul>
        <li>Copy, redistribute, or resell any content</li>
        <li>Reverse-engineer our analysis methods</li>
        <li>Use our content to train AI models</li>
        <li>Remove copyright or attribution notices</li>
      </ul>
      <p>Personal use of your own generated reports is permitted.</p>

      <h2>8. Prohibited Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service for any unlawful purpose</li>
        <li>Impersonate another person or submit someone else's voice without consent</li>
        <li>Attempt to breach security or access unauthorised areas</li>
        <li>Scrape, copy, or automate access to the Service</li>
        <li>Upload malicious code or interfere with the Service</li>
      </ul>

      <h2>9. Disclaimers</h2>
      <p>
        The Service is provided "as is" and "as available." We do not warrant:
      </p>
      <ul>
        <li>That the Service will be uninterrupted or error-free</li>
        <li>That reports will meet your expectations or produce specific outcomes</li>
        <li>That AI-generated content is accurate in every instance</li>
      </ul>
      <p>
        See our <a href="/disclaimer">Disclaimer</a> for further limitations.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, our total liability for any claim
        arising from your use of the Service is limited to the amount you paid us in
        the 6 months preceding the claim. We are not liable for indirect, incidental,
        or consequential damages.
      </p>

      <h2>11. Indemnity</h2>
      <p>
        You agree to indemnify and hold us harmless from any claim arising from your
        breach of these Terms or misuse of the Service.
      </p>

      <h2>12. Termination</h2>
      <p>
        We may suspend or terminate your access at any time for violation of these
        Terms. You may close your account at any time by contacting us.
      </p>

      <h2>13. Governing Law and Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. Any dispute will be subject to
        the exclusive jurisdiction of the courts in Chandigarh, U.T.
      </p>

      <h2>14. Contact</h2>
      <ul>
        <li><strong>VoiceMatrixAI</strong></li>
        <li><strong>Email:</strong> <a href="mailto:admin@voicematrix.in">admin@voicematrix.in</a></li>
        <li><strong>Address:</strong> Chandigarh, U.T., India</li>
      </ul>
    </LegalPage>
  );
}